import React, { useEffect, useState } from "react";
import axios from "axios";
import { sendMessage, listenToMessages } from "./chatService";

const Chat = () => {
    const [from, setFrom] = useState("learner@example.com"); // simulate login
    const [to, setTo] = useState("");
    const [messages, setMessages] = useState([]);
    const [newMsg, setNewMsg] = useState("");
    const [chatUsers, setChatUsers] = useState([]);

    useEffect(() => {
        const fetchSessions = async () => {
            try {
                const res = await axios.get("http://localhost:8080/api/sessions", {
                    headers: {
                        Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY4MzBlZTkyMmNjNWI5NzljOGFjMDcwYiIsImlhdCI6MTc0ODAzODIyOSwiZXhwIjoxNzQ4NjQzMDI5fQ.yFhOIR1wUH3vDLY1_0phCgPqObVkljSn85GdmqmCptU`
                    }
                });

                const users = new Set();
                res.data.forEach((session) => {
                    const partner =
                        session.learner.email === from
                            ? session.mentor.email
                            : session.learner.email;
                    users.add(partner);
                });

                const list = [...users];
                setChatUsers(list);
                setTo(list[0] || "");
                if (list.length === 0) {
                    alert("No chat sessions found. Make sure learner has a session.");
                }

            } catch (err) {
                console.error("Error loading sessions:", err);
            }
        };

        fetchSessions();
    }, [from]);

    useEffect(() => {
        if (from && to) {
            const unsubscribe = listenToMessages(from, to, setMessages);
            return () => unsubscribe();
        }
    }, [from, to]);

    const handleSend = async () => {
        if (newMsg.trim()) {
            await sendMessage(from, to, newMsg);
            setNewMsg("");
        }
    };

    return (
        <div style={{ padding: "2rem", fontFamily: "Arial" }}>
            <h2>📅 SkillSync Chat</h2>

            <div style={{ marginBottom: "1rem" }}>
                <strong>Chatting as:</strong> {from}
                <br />
                <label style={{ marginRight: "0.5rem" }}>To:</label>
                <select value={to} onChange={(e) => setTo(e.target.value)}>
                    {chatUsers.map((u) => (
                        <option key={u} value={u}>
                            {u}
                        </option>
                    ))}
                </select>
            </div>

            <div
                style={{
                    height: "300px",
                    overflowY: "scroll",
                    border: "1px solid #ccc",
                    padding: "1rem",
                    marginBottom: "1rem",
                }}
            >
                {messages.map((msg, i) => (
                    <div
                        key={i}
                        style={{
                            display: "flex",
                            justifyContent: msg.from === from ? "flex-end" : "flex-start",
                            margin: "0.5rem 0"
                        }}
                    >
                        <div
                            style={{
                                maxWidth: "60%",
                                background: msg.from === from ? "#dcf8c6" : "#f1f0f0",
                                padding: "0.5rem 1rem",
                                borderRadius: "12px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                textAlign: "left"
                            }}
                        >
                            <div style={{ fontSize: "0.9rem" }}>
                                <strong>{msg.from === from ? "You" : msg.from}</strong>
                            </div>
                            <div>{msg.message}</div>
                        </div>
                    </div>
                ))}

            </div>

            <input
                type="text"
                value={newMsg}
                onChange={(e) => setNewMsg(e.target.value)}
                placeholder="Type a message"
                style={{ padding: "0.5rem", width: "70%" }}
            />
            <button
                onClick={handleSend}
                style={{ padding: "0.5rem 1rem", marginLeft: "1rem" }}
            >
                Send
            </button>
        </div>
    );
};

export default Chat;
